import { NotifyHelper } from "../../../helpers/toast";
import { eQuyDinhSoBuoiTrenTuanActionsObj } from "../../action-types/category/IQuyDinhSoBuoiTrenTuanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const quyDinhSoBuoiTrenTuanActions = {
  ...generateActions(eQuyDinhSoBuoiTrenTuanActionsObj, "QUY_DINH_SO_BUOI_TREN_TUAN"),
  ...generateActionForKey(eQuyDinhSoBuoiTrenTuanActionsObj, "QUY_DINH_SO_BUOI_TREN_TUAN", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eQuyDinhSoBuoiTrenTuanActionsObj, "QUY_DINH_SO_BUOI_TREN_TUAN", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(eQuyDinhSoBuoiTrenTuanActionsObj, "QUY_DINH_SO_BUOI_TREN_TUAN", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
  ...generateActionForKey(eQuyDinhSoBuoiTrenTuanActionsObj, "QUY_DINH_SO_BUOI_TREN_TUAN", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
